import React from 'react'

// this component should be used in place of any <input type="number">
// it fixes an issue where the input value can be inadvertently changed by scrolling over the field with a mouse wheel
const NumberInput = React.forwardRef<
  HTMLInputElement,
  React.HTMLAttributes<HTMLInputElement> & {
    as?: React.ElementType
  }
>(({ ...props }, ref) => {
  return (
    // @ts-ignore React.WheelEvent<HTMLInputElement> does not generate a target with a blur property for some reason
    <input
      ref={ref}
      {...props}
      type="number"
      onWheel={(e) => e.target.blur()}
    />
  )
})

export default NumberInput
